export const REMOTE_COLLECTION = {
    COLLECTION: {
        queryKey: 'getRemoteCollections',
        url: '/remoteCollections'
    },
    EXPORT: {
        url: '/remoteCollections/export'
    },
    REFRESH_TRANSACTION_ALMA: {
        url: '/pollingUpdateTransactionFromExternalApplication'
    },
    SEND_MAIL: {
        url: '/remoteCollections/:remoteCollectionId/mailNotification'
    },
    TOTAL_REVENUE: {
        queryKey: 'getTotalRevenue',
        url: '/remoteCollectionsTotalRevenue'
    },
    TERMINAL: {
        COLLECTION: {
            queryKey: 'getTerminalRemoteCollections',
            url: '/posTerminals/:posTerminalId/remoteCollections'
        }
    },
    TRANSACTIONS: {
        COLLECTION: {
            url: '/remoteCollections/:remoteCollectionsId/transactions',
            queryKey: 'getRemoteCollectionTannsactions'
        },
        SEND_MAIL: {
            url: '/transactions/:transactionId/mailNotification'
        }
    },
    EXPORT_TRANSACTIONS: {
        url: '/remoteCollection/:uuid/transactionsExport'
    }
};